export const common = {
  // Navbar
  nav: {
    home: 'Accueil',
    why: 'Pourquoi',
    applications: 'Applications',
    products: 'Produits',
    resources: 'Ressources',
    contacts: 'Contacts',
    askAI: 'Demander à l\'IA',
    myths: 'Mythes vs Faits',
    o3101: 'O₃ 101',
    safety: 'Sécurité',
    faq: 'FAQ',
    blog: 'Blog',
  },
  
  // Hero
  hero: {
    badge: 'Hub Éducatif • Sécurité d\'abord • Éco-tech',
    titleA: 'OzoneFusion 2.0 — L\'ozone bien expliqué. Mieux utilisé.',
    titleB: 'Sécurité, clarté, technologie. Bienvenue dans le hub de l\'ozone.',
    titleC: 'O₃ sans confusion : guides rapides, FAQ, ressources et assistant IA.',
    subtitle: 'Comprendre l\'ozone. L\'utiliser en toute sécurité.',
    cta1: 'Découvrir O₃ 101',
    cta2: 'Guide de Sécurité',
  },
  
  // Why Section
  why: {
    title: 'Pourquoi un hub éducatif',
    subtitle: 'Information claire, sécurité garantie, durabilité au cœur',
    clarity: {
      title: 'Clarté',
      description: 'Informations scientifiques accessibles à tous, sans jargon inutile.',
    },
    safety: {
      title: 'Sécurité',
      description: 'Protocoles vérifiés et directives pour une utilisation responsable de l\'ozone.',
    },
    sustainability: {
      title: 'Durabilité',
      description: 'Technologie écologique qui respecte l\'environnement et la santé.',
    },
  },
  
  // Myths vs Facts
  myths: {
    title: 'Mythes vs Faits',
    subtitle: 'Démystifier les idées reçues sur l\'ozone',
    myth1: 'C\'est toujours dangereux',
    fact1: 'Cela dépend de la dose, du temps, de la ventilation et des procédures',
    myth2: 'C\'est magique',
    fact2: 'C\'est de la chimie : puissant lorsqu\'il est géré correctement',
    myth3: 'Ça endommage tout',
    fact3: 'Compatible avec la plupart des matériaux lorsqu\'il est bien utilisé',
    myth4: 'Pas besoin de ventiler',
    fact4: 'La ventilation est essentielle pour la sécurité',
  },
  
  // Safety
  safety: {
    title: 'La sécurité d\'abord',
    subtitle: 'Les 6 règles d\'or pour une utilisation responsable',
    rule1: {
      title: 'Ventilation',
      description: 'Aérez toujours les espaces après le traitement',
    },
    rule2: {
      title: 'Temps corrects',
      description: 'Respectez les temps d\'exposition recommandés',
    },
    rule3: {
      title: 'Concentrations',
      description: 'Utilisez les doses appropriées pour chaque application',
    },
    rule4: {
      title: 'Enfants et animaux',
      description: 'Gardez-les éloignés pendant et après le traitement',
    },
    rule5: {
      title: 'Matériaux compatibles',
      description: 'Vérifiez la compatibilité avec le caoutchouc et les plastiques',
    },
    rule6: {
      title: 'Maintenance',
      description: 'Inspectez régulièrement votre appareil',
    },
  },
  
  // Applications
  applications: {
    title: 'Applications de l\'ozone',
    subtitle: 'Solutions pour chaque besoin',
    tabHome: 'Maison',
    tabB2B: 'B2B',
    home: {
      title: 'Pour votre maison',
      description: 'Assainissement naturel pour les environnements domestiques',
    },
    hotel: {
      title: 'Hôtel & Hospitalité',
      description: 'Hygiène professionnelle pour chambres et espaces communs',
    },
    laundry: {
      title: 'Blanchisseries',
      description: 'Lavage écologique et efficace',
    },
    b2b: {
      title: 'Solutions B2B',
      description: 'Technologie pour entreprises et professionnels',
    },
    discoverProducts: 'Découvrir les produits',
  },
  
  // Products
  products: {
    title: 'Nos produits',
    subtitle: 'Technologie certifiée pour chaque besoin',
    cta: 'En savoir plus',
  },
  
  // Resources
  resources: {
    title: 'Ressources gratuites',
    subtitle: 'Téléchargez des guides, des listes de contrôle et du matériel éducatif pour une utilisation sûre de l\'ozone',
    checklist: {
      title: 'Liste de Sécurité',
      description: 'Liste complète des contrôles à effectuer avant, pendant et après chaque traitement.',
      cta: 'Télécharger PDF',
    },
    guide: {
      title: 'Guide Rapide O₃',
      description: 'Manuel pratique avec tout ce que vous devez savoir pour commencer en toute sécurité.',
      cta: 'Télécharger PDF',
    },
    poster: {
      title: 'Affiche Informative',
      description: 'Affiche A4 à imprimer avec les règles d\'or pour une utilisation sûre de l\'ozone.',
      cta: 'Télécharger PDF',
    },
  },
  
  // Blog
  blog: {
    title: 'Éducation & Sécurité',
    subtitle: 'Articles, guides et analyses sur l\'ozone',
    comingSoon: 'Contenu à venir',
    comingSoonDesc: 'Nous préparons des articles et des guides détaillés pour vous. Revenez bientôt !',
    cta: 'S\'abonner à la newsletter',
  },
  
  // AI Assistant
  ai: {
    badge: 'Assistant IA Avancé',
    title: 'Votre Coach de Sécurité O₃',
    titleHighlight: 'Coach de Sécurité',
    subtitle: 'Un assistant intelligent toujours à vos côtés pour répondre à toutes vos questions sur l\'ozone, la sécurité d\'utilisation et le bonnes pratiques. Chat ou voix, quand vous voulez.',
    features: {
      friendly: {
        title: 'Amical et Clair',
        description: 'Des réponses simples et compréhensibles, senza tecnicismi inutili',
      },
      responsible: {
        title: 'Responsable',
        description: 'Garde-fous de sécurité : pas de promesses médicales, uniquement des informations validées',
      },
      knowledge: {
        title: 'Base de Connaissances',
        description: 'Accès à tous les guides, FAQ et listes de contrôle du site',
      },
      available: {
        title: 'Toujours Disponible',
        description: 'Chat et voix, 24/7, pour répondre à vos questions',
      },
    },
    ctaCard: {
      title: 'Prêt à poser des questions ?',
      description: 'Cliquez sur le bouton turquoise en bas à droite pour commencer une conversation. Vous pouvez écrire ou parler directement avec le Coach.',
      cta: 'Ouvrir le Coach IA',
    },
    examplesTitle: 'Ou essayez avec l\'une de ces questions :',
    question1: 'Comment fonctionne l\'ozone ?',
    question2: 'Est-ce sûr pour ma maison ?',
    question3: 'Combien de temps dois-je ventiler ?',
    question4: 'Puis-je l\'utiliser avec des animaux ?',
    question5: 'Quelles concentrations sont sûres ?',
    question6: 'Comment désinfecter les tissus ?',
    safetyNotice: {
      title: 'Note importante sur la sécurité',
      description: 'Le Coach IA fournit des informations éducatives basées sur des normes et des recherches scientifiques. Il n\'offre pas de conseils médicaux ou thérapeutiques. Pour des questions cliniques ou de santé, consultez toujours un professionnel qualifié. Le Coach vous guidera vers les bonnes ressources.',
    },
  },
  
  // About
  about: {
    title: 'Qui sommes-nous',
    subtitle: 'Purevital / OzoneFusion',
    mission: 'Notre mission',
    missionText: 'Rendre la technologie de l\'ozone accessible, sûre et compréhensible pour tous. Nous croyons en un avenir plus propre grâce à l\'éducation et à l\'innovation responsable.',
    values: 'Nos valeurs',
    value1: 'Transparence scientifique',
    value2: 'Sécurité d\'abord',
    value3: 'Durabilité environnementale',
    value4: 'Innovation responsable',
  },
  
  // Contact
  contact: {
    title: 'Contactez-nous',
    subtitle: 'Nous sommes là pour répondre à vos questions',
    name: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    message: 'Message',
    send: 'Envoyer le message',
    whatsapp: 'Écrivez-nous sur WhatsApp',
    emailUs: 'Envoyez-nous un email',
    newsletter: 'S\'abonner à la newsletter',
    newsletterDesc: 'Recevez des mises à jour, des guides et des conseils de sécurité',
    subscribe: 'S\'abonner',
    success: 'Message envoyé avec succès !',
    error: 'Erreur lors de l\'envoi. Veuillez réessayer.',
  },
  
  // Footer
  footer: {
    tagline: 'Éducation, sécurité et technologie pour un avenir plus propre',
    explore: 'Explorer',
    education: 'Éducation',
    company: 'Entreprise',
    support: 'Support',
    legal: 'Légal',
    contactUs: 'Contactez-nous',
    faq: 'FAQ',
    guides: 'Sécurité et Directives',
    community: 'Communauté',
    privacy: 'Politique de Confidentialité',
    cookies: 'Politique de Cookies',
    disclaimer: 'Avertissement',
    terms: 'Conditions Générales',
    allProducts: 'Tous les Produits',
    compareProducts: 'Comparer les Produits',
    rights: 'Tous droits réservés',
    poweredBy: 'Powered by Readdy',
  },
  
  // Common
  common: {
    readMore: 'Lire la suite',
    learnMore: 'En savoir plus',
    download: 'Télécharger',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    loading: 'Chargement...',
  },
};
